export var TEAM_ICONS = {
  SMART_TEAM: 'sparkles',
  TEAM: 'team'
};
export function getTeamIcon(isSmartTeam) {
  if (isSmartTeam) {
    return TEAM_ICONS.SMART_TEAM;
  }
  return TEAM_ICONS.TEAM;
}